export default __webpack_public_path__ + "static/media/gallery_10.90a052d7.jpg";